document.addEventListener('DOMContentLoaded', function () {
  const accordionTriggers = document.querySelectorAll('.accordion-trigger');

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const content = document.getElementById(this.getAttribute('aria-controls'));
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Toggle states
      this.setAttribute('aria-expanded', !isExpanded);
      content.setAttribute('aria-hidden', isExpanded);

      // Animate height
      if (!isExpanded) {
        // Opening
        content.style.height = content.scrollHeight + 'px';
      } else {
        // Closing
        content.style.height = content.scrollHeight + 'px';
        // Force a reflow
        content.offsetHeight;
        content.style.height = '0px';
      }
    });
  });

  // Handle transition end
  document.querySelectorAll('.accordion-content').forEach((content) => {
    content.addEventListener('transitionend', function () {
      if (this.getAttribute('aria-hidden') === 'true') {
        this.style.height = '0px';
      } else {
        this.style.height = 'auto';
      }
    });
  });
});
